import { createContext, useContext } from "react";

export const BookingPageContext = createContext();

export const useBookingPageContext = () => useContext(BookingPageContext);
